// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Benefits Landing Content Styles */
.punRG2 {
  width: 400px;
  padding: var(--spacing-3, 24px) !important;
  margin: 0;
  overflow: visible;
  border-radius: 4px !important;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  /* Remove auto centering since parent will handle centering */
}

._IXVPQ {
  min-height: 704px;
  height: auto;
}

.q1uBjX {
  min-height: 1050px;
  height: auto;
  max-height: none;
}

.Q04Hlj {
  margin-bottom: var(--spacing-3, 24px);
  min-height: auto;
  overflow: visible;
  width: 100%;
}

.DVjsbL {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--type-title-lg-font-size, 20px);
  font-weight: var(--type-title-lg-font-weight, 600) !important;
  line-height: var(--type-title-lg-line-height, 1.424em);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  padding: 0;
  text-align: left;
  white-space: pre-line;
  word-break: normal;
  overflow-wrap: normal;
  display: block;
  visibility: visible;
  opacity: 1;
  width: 100%;
  max-width: 352px;
  min-height: 56px;
}

.G_xSUx {
  text-align: center;
  max-width: 100% !important;
}

.hMekOT {
  margin-bottom: 0;
  overflow: visible;
  flex-shrink: 0;
}

.w9xD9_ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
}

.hQuo6H {
  display: flex;
  gap: var(--spacing-2, 16px);
  align-items: flex-start;
}

.ok_Il_ {
  width: 32px;
  height: 32px;
  background: var(--background-neutral-medium, #f2f2f2);
  border-radius: var(--radius-circle, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ok_Il_ svg {
  width: 16px;
  height: 16px;
  color: var(--color-primary, #d64000);
}

.eSjfVZ {
  flex: 1;
}

.ufMyyM {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--type-paragraph-md-font-size, 14px);
  font-weight: var(--type-paragraph-md-regular-font-weight, 400);
  line-height: var(--type-paragraph-md-regular-line-height, 1.421em);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.ufMyyM strong {
  font-weight: var(--font-weight-semibold, 600);
}

.qT94fE {
  margin-top: var(--spacing-3, 24px);
  margin-bottom: 0;
  flex-shrink: 0;
  width: 100%;
}

.ikwzBK {
  width: 100%;
}

.M_JUHR {
  position: relative;
  text-align: center;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8em;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: var(--spacing-2, 16px) 0;
  padding: 0 16px;
}

.M_JUHR::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--border-neutral-light, #f2f2f2);
  z-index: 1;
}

.M_JUHR::after {
  content: attr(data-separator-text);
  position: relative;
  padding: 0 8px;
  z-index: 2;
}

.rjU7Sf {
  margin-top: var(--spacing-2, 16px);
}

.kVlL_v {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 16px;
}

.R1QCui {
  margin-top: 16px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .punRG2 {
    max-width: none;
    padding: 20px !important;
  }

  .DVjsbL {
    font-size: 18px;
  }

  .ufMyyM {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .punRG2 {
    padding: 16px !important;
  }

  .DVjsbL {
    font-size: 16px;
  }

  .hQuo6H {
    gap: 12px;
  }

  .ok_Il_ {
    width: 28px;
    height: 28px;
    border-radius: 14px;
  }

  .ok_Il_ svg {
    width: 14px;
    height: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BenefitsLandingContent/BenefitsLandingContent.module.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,YAAY;EACZ,0CAA0C;EAC1C,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,+CAA+C;EAC/C,6DAA6D;EAC7D,sDAAsD;EACtD,wCAAwC;EACxC,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iEAAiE;EACjE,mDAAmD;EACnD,8DAA8D;EAC9D,kEAAkE;EAClE,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iEAAiE;EACjE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gDAAgD;EAChD,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Benefits Landing Content Styles */\n.landingContent {\n  width: 400px;\n  padding: var(--spacing-3, 24px) !important;\n  margin: 0;\n  overflow: visible;\n  border-radius: 4px !important;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  /* Remove auto centering since parent will handle centering */\n}\n\n.landingContentClient {\n  min-height: 704px;\n  height: auto;\n}\n\n.landingContentAccounting {\n  min-height: 1050px;\n  height: auto;\n  max-height: none;\n}\n\n.titleSection {\n  margin-bottom: var(--spacing-3, 24px);\n  min-height: auto;\n  overflow: visible;\n  width: 100%;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--type-title-lg-font-size, 20px);\n  font-weight: var(--type-title-lg-font-weight, 600) !important;\n  line-height: var(--type-title-lg-line-height, 1.424em);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  white-space: pre-line;\n  word-break: normal;\n  overflow-wrap: normal;\n  display: block;\n  visibility: visible;\n  opacity: 1;\n  width: 100%;\n  max-width: 352px;\n  min-height: 56px;\n}\n\n.titleCentered {\n  text-align: center;\n  max-width: 100% !important;\n}\n\n.featuresSection {\n  margin-bottom: 0;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.featuresContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n}\n\n.featureItem {\n  display: flex;\n  gap: var(--spacing-2, 16px);\n  align-items: flex-start;\n}\n\n.featureIcon {\n  width: 32px;\n  height: 32px;\n  background: var(--background-neutral-medium, #f2f2f2);\n  border-radius: var(--radius-circle, 50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.featureIcon svg {\n  width: 16px;\n  height: 16px;\n  color: var(--color-primary, #d64000);\n}\n\n.featureContent {\n  flex: 1;\n}\n\n.featureDescription {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--type-paragraph-md-font-size, 14px);\n  font-weight: var(--type-paragraph-md-regular-font-weight, 400);\n  line-height: var(--type-paragraph-md-regular-line-height, 1.421em);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.featureDescription strong {\n  font-weight: var(--font-weight-semibold, 600);\n}\n\n.actionSection {\n  margin-top: var(--spacing-3, 24px);\n  margin-bottom: 0;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.button {\n  width: 100%;\n}\n\n.buttonSeparator {\n  position: relative;\n  text-align: center;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.8em;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: var(--spacing-2, 16px) 0;\n  padding: 0 16px;\n}\n\n.buttonSeparator::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: var(--border-neutral-light, #f2f2f2);\n  z-index: 1;\n}\n\n.buttonSeparator::after {\n  content: attr(data-separator-text);\n  position: relative;\n  padding: 0 8px;\n  z-index: 2;\n}\n\n.additionalSection {\n  margin-top: var(--spacing-2, 16px);\n}\n\n.networkLinkContainer {\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.additionalContent {\n  margin-top: 16px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .landingContent {\n    max-width: none;\n    padding: 20px !important;\n  }\n\n  .title {\n    font-size: 18px;\n  }\n\n  .featureDescription {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .landingContent {\n    padding: 16px !important;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .featureItem {\n    gap: 12px;\n  }\n\n  .featureIcon {\n    width: 28px;\n    height: 28px;\n    border-radius: 14px;\n  }\n\n  .featureIcon svg {\n    width: 14px;\n    height: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landingContent": `punRG2`,
	"landingContentClient": `_IXVPQ`,
	"landingContentAccounting": `q1uBjX`,
	"titleSection": `Q04Hlj`,
	"title": `DVjsbL`,
	"titleCentered": `G_xSUx`,
	"featuresSection": `hMekOT`,
	"featuresContainer": `w9xD9_`,
	"featureItem": `hQuo6H`,
	"featureIcon": `ok_Il_`,
	"featureContent": `eSjfVZ`,
	"featureDescription": `ufMyyM`,
	"actionSection": `qT94fE`,
	"button": `ikwzBK`,
	"buttonSeparator": `M_JUHR`,
	"additionalSection": `rjU7Sf`,
	"networkLinkContainer": `kVlL_v`,
	"additionalContent": `R1QCui`
};
module.exports = ___CSS_LOADER_EXPORT___;
